import CryptoJS from 'crypto-js'
/*
* key： 密钥（加密解密密钥同一个）
*/
const key = 'syzg@hyds.31025'
/*
* message:需要加密的字符串，对象加密需要转成json字符串
*/
const encryptDes = (message) => {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const option = { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, option)
  return encrypted.ciphertext.toString() // 返回hex格式密文，如需返回base64格式：encrypted.toString()
}
/*
* message:需要解密的字符串，
* 若message是base64格式，则无需转16进制hex，直接传入message即可
*/
const decryptDes = (message) => {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Hex.parse(message)
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  )
  return decrypted.toString(CryptoJS.enc.Utf8)
}
const encryptSha1 = (message) => {
  return CryptoJS.SHA1(message).toString(CryptoJS.enc.Hex)
}
const getUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
export { encryptDes, decryptDes, encryptSha1, getUuid }
